import AppCrashBoundary from '@hellodarwin/core/lib/components/error/crash-boundary';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

const CrashBoundaryWrapper = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();

  // resetKey clears an active crash on navigation without remounting the provider tree.
  return (
    <AppCrashBoundary resetKey={pathname} app="client">
      {children}
    </AppCrashBoundary>
  );
};

export default CrashBoundaryWrapper;
